import React, { Component } from 'react';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../constants/text';
import { colors } from '../../../constants/colors';
import { DESKTOP_FAT_GUTTER, DESKTOP_THIN_GUTTER, MOBILE_GUTTER } from '../../../constants/layout';
import {
  smallerThanOrEqualTo,
  biggerThanOrEqualTo,
  breakpoints,
} from '../../../core/util/styledComponents';

const Styled = styled.div`
  font-family: ${fontFamily.book};
  -webkit-font-smoothing: antialiased;
  background-color: ${colors.blueMonday};
  color: ${colors.white};
  padding-top: 23px;
  padding-bottom: 23px;
  font-size: ${fontSize.mediumSmall};
  line-height: 22px;
  ${smallerThanOrEqualTo.md`
    padding-right: ${MOBILE_GUTTER}px;
    padding-left: ${MOBILE_GUTTER}px;
  `}
  ${biggerThanOrEqualTo.md`
    padding-right: ${DESKTOP_FAT_GUTTER}px;
    padding-left: ${DESKTOP_FAT_GUTTER}px;
  `}
  ${biggerThanOrEqualTo.lg`
    padding-right: ${DESKTOP_THIN_GUTTER}px;
    padding-left: ${DESKTOP_THIN_GUTTER}px;
  `}
`;

const TextContainer = styled.div`
  max-width: ${breakpoints.lg};
  margin: 0 auto;
`;

class Header extends Component {
  render() {
    return (
      <Styled>
        <TextContainer>
          In the event of a medical emergency, dial 911 or visit your closest emergency room
          immediately.
        </TextContainer>
      </Styled>
    );
  }
}

export default Header;
